'use client';

import { Carousel, useCarousel } from '../../../../../domains/Layout/Carousel/Carousel';
import {
    AgencyCard,
    Props as AgencyCardProps,
} from '../../../../../shared/components/AgencyCard/AgencyCard';
import { AgencyHighlightBlockSliceProps } from '../Slices/AgencyHighlightBlockSlice';

export type AgencyHighlightCarouselProps = {
    agencies: AgencyCardProps['agency'][];
    lightText?: boolean;
    sliceIndex?: number;
    title: AgencyHighlightBlockSliceProps['title'];
};

export function AgencyHighlightCarousel({
    agencies,
    lightText,
    sliceIndex,
    title,
}: AgencyHighlightCarouselProps) {
    const carouselProps = useCarousel();

    return (
        <Carousel
            {...carouselProps}
            slidesVisibleRules={{ sm: 3, md: 4, lg: 6, xl: 6, xxl: 6 }}
            trackingInformation={{
                navClick: {
                    block: 'agencies',
                    block_index: sliceIndex ? sliceIndex + 1 : 0,
                    block_title: title ?? undefined,
                },
            }}
        >
            {agencies.map((agency, index) => {
                return (
                    <AgencyCard
                        key={agency.id}
                        agency={agency}
                        image={{
                            priority: false,
                            sizes: '300px',
                        }}
                        trackingInformation={{
                            click: {
                                agency_id: agency.id,
                                agency_slug: agency.slug,
                                agency_better_trip_index: agency.betterTripIndex,
                                block: 'agencies',
                                card_number: index + 1,
                                tool_counter: 0,
                            },
                        }}
                        showDestinationName
                        showReview={false}
                        showDescription={false}
                        lightText={lightText}
                    />
                );
            })}
        </Carousel>
    );
}
